<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
  <mat-progress-spinner [color]="color" mode="indeterminate" [diameter]="diameter"></mat-progress-spinner>
  <span translate style="font-size: small" *ngIf="message; else content">{{ message }}</span>
  <ng-template #content>
    <span translate style="font-size: small">
      <ng-content></ng-content>
    </span>
  </ng-template>
</div>
